import React from "react";
import NormalToggleInputField from "../../../../Universal/NormalToggleInputField.component";

const MessageSendCard = ({ title, color, onChange, name, inputRef }) => {
  return (
    <div className="w-full flex-row align-center justify-between">
      <div className="flex-row align-center g-1">
        <div
          style={{
            width: "4rem",
            height: "4rem",
            borderRadius: "50%",
            background: color,
          }}
        ></div>
        <p className="poppins t-16">{title}</p>
      </div>
      <NormalToggleInputField
        ref={inputRef}
        name={name}
        type={"checkbox"}
        value={name}
        setFieldValue={(name, value) => onChange(name, value)}
      />
    </div>
  );
};

export default MessageSendCard;
